export type HDStethDeviceMode = '6-bit' | '12-bit'

/** ECG, HS and MUR all arrive at 640 samples/s (HDSteth2, 12-bit mode, measured 2026-09-03). */
export const HDSTETH_SAMPLE_RATE_HZ = 640

export interface HDStethBatch {
  ts: number
  mode: HDStethDeviceMode
  ecg: number[]
  hs: number[]
  mur: number[]
  /** Older connectors omit this; fall back to HDSTETH_SAMPLE_RATE_HZ. */
  ecgSampleRateHz?: number
  simulated?: boolean
}

/** Validate the local connector boundary without accepting empty or oversized device announcements. */
export function isHDStethBatch(value: unknown): value is HDStethBatch {
  if (typeof value !== 'object' || value === null) return false
  const batch = value as Record<string, unknown>
  if (batch.mode !== '12-bit' && batch.mode !== '6-bit') return false
  if (typeof batch.ts !== 'number' || !Number.isFinite(batch.ts)) return false
  if (batch.ecgSampleRateHz !== undefined && (typeof batch.ecgSampleRateHz !== 'number' || !Number.isFinite(batch.ecgSampleRateHz) || batch.ecgSampleRateHz < 50 || batch.ecgSampleRateHz > 2000)) return false
  if (batch.simulated !== undefined && typeof batch.simulated !== 'boolean') return false
  const channels = [batch.ecg, batch.hs, batch.mur]
  return channels.every((channel, index) => Array.isArray(channel) && channel.length <= 4096 && channel.every((sample: unknown) =>
    typeof sample === 'number' && Number.isInteger(sample) && sample >= 0 && sample <= (index === 0 && batch.mode === '12-bit' ? 4095 : 63)))
    && channels.some((channel) => (channel as number[]).length > 0)
}
